export default "__VITE_ASSET__CSPgB$Qi__"